import { initializeFormDefinitionStore } from "csi/middleware/form/formUtility";
import { useLocalStore } from "designSystem/hooks";
import { useLocale } from "designSystem/locale";
import React, { FunctionComponent } from "react";
import { FormDefinitionStoreContext } from "./FormDefinitionStore";
import { FormPreview } from "./FormPreview";

const ContextProvider: FunctionComponent = function ContextProvider() {
	const loc = useLocale();
	async function storeInitializer() {
		const formDefinitionStore = await initializeFormDefinitionStore(loc);
		return formDefinitionStore;
	}
	const formDefinitionStore = useLocalStore(storeInitializer);
	return (
		<FormDefinitionStoreContext.Provider value={formDefinitionStore}>
			{formDefinitionStore && (
				<FormPreview />
			)}
		</FormDefinitionStoreContext.Provider>
	);
};

export default ContextProvider;